import TagManager from 'react-gtm-module'

export const checklistDataLayer = (
  event: string,
  page: 'Home' | 'MembershipsOverview',
  checklist: 'Launch' | 'Memberships',
  step?: string,
) => {
  TagManager.dataLayer({ dataLayer: { event, page, checklist, step } })
}
